export enum SEVERITY {
  NORMAL = 10,
  CRITICAL = 20,
}

export const SEVERITY_NAME = {
  [SEVERITY.NORMAL]: 'Normal',
  [SEVERITY.CRITICAL]: 'Critical',
};
